export class AccountAttributeDto {
  enabled: boolean;
  referenceNumber: string;

  constructor(d?: AccountAttributeDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
